import { Dialog, Transition } from '@headlessui/react'

import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { LogoSvg } from 'icons'
import { MenuItemProps } from 'components/MenuItem/MenuItem'
import React from 'react'
import Sidebar from 'components/Sidebar'
import { classNames } from 'helpers'

interface SidebarLayoutProps {
  sidebarOpen: boolean
  setSidebarOpen: any
  children: any
  sidebarNavigation: MenuItemProps[]
  navigation: any
}

const SidebarLayout: React.FC<SidebarLayoutProps> = ({
  children,
  sidebarOpen,
  setSidebarOpen,
  sidebarNavigation,
  navigation,
  ...args
}) => {
  return (
    <div className="flex overflow-hidden" {...args}>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-40 flex md:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-opacity-75 border-gray-2" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative flex flex-col flex-1 w-full max-w-xs bg-white">
              {/* Phone screens */}
              {/* Close button */}
              {/* <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute top-0 right-0 pt-2 -mr-12">
                  <button
                    type="button"
                    className="flex items-center justify-center w-10 h-10 ml-1 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                    onClick={() => setSidebarOpen(false)}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <CrossSvg className="w-6 h-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child> */}
              <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                <div className="flex items-center flex-shrink-0 px-4">
                  <LogoSvg className="w-auto h-8" />
                </div>
                <nav className="px-2 mt-5 space-y-1">
                  {navigation.map((item: any) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={classNames(
                        item.current
                          ? 'bg-gray-0 text-black'
                          : 'bg-gray-0 hover:bg-gray-0 hover:text-black',
                        'group flex items-center px-2 py-2 text-base font-medium rounded-md'
                      )}
                    >
                      <item.icon
                        className={classNames(
                          item.current
                            ? 'bg-white'
                            : 'text-gray-1 group-hover:bg-white',
                          'mr-4 flex-shrink-0 h-6 w-6'
                        )}
                        aria-hidden="true"
                      />
                      {item.name}
                    </Link>
                  ))}
                </nav>
              </div>
            </div>
          </Transition.Child>
          <div className="flex-shrink-0 w-14">
            {/* Force sidebar to shrink to fit close icon */}
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex flex-col w-40">
          <Sidebar sidebarNavigation={sidebarNavigation} />
        </div>
      </div>
      <div className="flex flex-col flex-1">
        <main className="relative z-0 flex-1 focus:outline-none">
          <div>{children}</div>
        </main>
      </div>
    </div>
  )
}

SidebarLayout.defaultProps = {}

export default SidebarLayout
